import {Injectable} from "@angular/core";
import {AbstractBaseComponent} from "../app.baseComponent";
import {CanActivate, Router} from "@angular/router";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import {CurrentUserStateService} from "../appServices/current-user-state.service";
import { isTransitionedFromMentorHub } from "../pages/gamification/experience-mode";

@Injectable()
export class AdminMentoringGuard extends AbstractBaseComponent implements CanActivate {
    constructor(private authService: AuthenticationHelper, private utility: UtilityHelper, private route: Router, private currentUserStateService: CurrentUserStateService) {
        super();
    }

    canActivate() {
        if (this.authService.isLoggedIn() && (this.utility.myDomain == this.LOCAL_DOMAIN || this.utility.myDomain == this.MENTORING_DOMAIN || this.utility.myDomain == this.ADMIN_DOMAIN)) {
            const isSuperAdmin = this.currentUserStateService.isSuperAdmin();
            const openAdmin = this.utility.openAdmin || this.utility.getItem('open_admin') === 'true';
            if (
                this.utility.getItem('role') === 'mentor' &&
                this.utility.hasMentorHubAccess &&
                !isTransitionedFromMentorHub(this.utility) &&
                !isSuperAdmin &&
                !openAdmin
            ) {
                this.route.navigate(['/mentor-hub/dashboard']);
                return false;
            }
            return true
        } else {
            this.route.navigate(['']);
            return false
        }
    }
}